import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Supabase credentials missing!');
  console.error('Please add the following to your .env file:');
  console.error('VITE_SUPABASE_URL=your_supabase_project_url');
  console.error('VITE_SUPABASE_ANON_KEY=your_supabase_anon_key');
  console.error('Get these values from: https://supabase.com/dashboard/project/YOUR_PROJECT/settings/api');
  
  // Don't throw error immediately, let the app show a better error message
  console.error('⚠️ Continuing with invalid config - app will show error message');
}

// Validate URL format
if (supabaseUrl && (!supabaseUrl.startsWith('https://') || !supabaseUrl.includes('.supabase.co'))) {
  console.error('❌ Invalid Supabase URL format!');
  console.error('Expected format: https://your-project-id.supabase.co');
  console.error('Current value:', supabaseUrl);
  console.error('⚠️ Continuing with invalid URL - app will show error message');
}

// Validate anon key format (basic check)
if (supabaseAnonKey && supabaseAnonKey.length < 100) {
  console.error('❌ Invalid Supabase anon key!');
  console.error('The anon key should be a long JWT token (100+ characters)');
  console.error('Current length:', supabaseAnonKey.length);
  console.error('⚠️ Continuing with invalid key - app will show error message');
}

if (supabaseUrl && supabaseAnonKey) {
  console.log('✅ Supabase client configured successfully');
  console.log('Project URL:', supabaseUrl);
} else {
  console.warn('⚠️ Supabase client created with missing credentials');
}

// Create a safe fallback URL and key to prevent createClient from throwing
const safeUrl = supabaseUrl || 'https://wshkcylwrsyhejwufulq.supabase.co';
const safeKey = supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndzaGtjeWx3cnN5aGVqd3VmdWxxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIwODUyMTIsImV4cCI6MjA2NzY2MTIxMn0.lYMZsz3QB7oLlQdD_VQp3i83Zr3jgN3q-O9_Osan8co';

export const supabase = createClient(safeUrl, safeKey);

// Export a flag to check if credentials are actually configured
export const isConfigured = !!(supabaseUrl && supabaseAnonKey && supabaseUrl.includes('.supabase.co'));

export type SupabaseUser = {
  id: string;
  email?: string;
  user_metadata?: {
    name?: string;
    avatar_url?: string;
  };
};